import "./App.css";
import { Routes, Route, useNavigate } from "react-router";
import Main from "./Main/Main";
import OAuthLogin from "./Auth/OAuthLogin";
import Wrapper from "./Auth/wrapper";
import UnAthorised from "./Auth/UnAuthorised";

function App() {
    return (
        <Routes>
            <Route
                path="/"
                element={
                    <Wrapper>
                        <Main />
                    </Wrapper>
                }
            />
            <Route
                path="/auth/callback"
                element={<OAuthLogin />}
            />
            <Route
                path="noaccess"
                element={<UnAthorised />}
            />
        </Routes>
    );
}

export default App;
